fx.ns("shared.popups", class ProposeRegister extends shared.popups.BasePersonPopup{
    
    constructor(data, exitAsked)
    {
        super(data, fx.get("assets").personAdvice);
        this.contentWidth = 460;
        this.contentHeight = 285;

        this.destroyOnSwitch = true;

        this._exitAsked = exitAsked;
        this.showClose = exitAsked;
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("click", this.onQuit, this.cancelButton);
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Ne perdez pas votre travail."), className:"title"}));
        this.addChild(new fx.components.Text({text:fx.text("Sauvegardez votre travail, c'est simple et gratuit!<br><br>Votre création sera conservé sans limite de temps, et vous pourrez continuer à la modifier quand vous le souhaitez."), className:"text"}));

        
        this.okButton = new fx.components.Button({label : fx.text("Sauver"), type : "filled"});
        this.cancelButton = new fx.components.Button( {label : this._exitAsked ? fx.text("Quitter") : fx.text("Plus tard")} );

        this.addFooterChild(this.cancelButton, {width : 200})
        this.addFooterChild(this.okButton, {width : 200})
    }


    onConfirm()
    {
        this.close();
        this.data.event("register-user");
    }

    onClose()
    {
        super.onClose();
        this.data.event("refused-register");
    }

    onQuit()
    {
        if (this._exitAsked)
            this.data.event("navigate-back");
        else
            this.close();
    }


});